<template>
  <div v-if="!isMobile()">
    <div class="page-header clear-filter" filter-color="black2">
      <img src="/img/mydrago/img-bg-mydrago.png" width="100%" height="400px" />
      <div
        class="bg_bonus-area"
        v-bind:style="{ height: getTotalHeight() }"
      ></div>
      <div
        style="
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0px;
          left: 0px;
        "
      >
        <img
          src="/img/genesis/deco-light.png"
          style="
            position: relative;
            margin-top: 136px;
            margin-left: calc(50% - 156px);
          "
        />
        <div class="MY-DRAGO">MY DRAGO</div>
      </div>
      <div style="position: absolute; top: 420px; width: 100%; height: 100px">
        <div
          style="
            position: absolute;
            top: 30px;
            left: calc(50% - 250px);
            width: 150px;
            height: 50px;
            cursor: pointer;
          "
          @click="onClickMyDrago(0)"
        >
          <div
            v-if="tab.mydrago == 0"
            style="
              font-family: Poppins;
              font-size: 20px;
              font-weight: 600;
              text-align: center;
              color: #fff;
            "
          >
            Dragos
          </div>
          <div
            v-else
            style="
              font-family: Poppins;
              font-size: 20px;
              font-weight: 600;
              text-align: center;
              color: #576288;
            "
          >
            Dragos
          </div>
          <div
            v-if="tab.mydrago == 0"
            style="
              height: 4px;
              border: solid 0 #000;
              background-color: #0d6eff;
              position: absolute;
              bottom: 0px;
              width: 100%;
            "
          ></div>
        </div>
        <div
          style="
            position: absolute;
            top: 30px;
            left: calc(50% + 100px);
            width: 150px;
            height: 50px;
            cursor: pointer;
          "
          @click="onClickMyDrago(1)"
        >
          <div
            v-if="tab.mydrago == 1"
            style="
              font-family: Poppins;
              font-size: 20px;
              font-weight: 600;
              text-align: center;
              color: #fff;
            "
          >
            Rental
          </div>
          <div
            v-else
            style="
              font-family: Poppins;
              font-size: 20px;
              font-weight: 600;
              text-align: center;
              color: #576288;
            "
          >
            Rental
          </div>
          <div
            v-if="tab.mydrago == 1"
            style="
              height: 4px;
              border: solid 0 #000;
              background-color: #0d6eff;
              position: absolute;
              bottom: 0px;
              width: 100%;
            "
          ></div>
        </div>
      </div>
      <div
        style="
          width: 100%;
          height: 1px;
          opacity: 0.7;
          border: solid 0 #000;
          background-color: #2a2e45;
          position: absolute;
          top: 500px;
          left: 0px;
        "
      ></div>
      <div v-if="tab.mydrago == 0">
        <div
          style="
            position: absolute;
            top: 520px;
            height: 20px;
            right: calc((100% - 1100px) / 2 + 22px);
          "
        >
          <div
            style="
              font-family: Poppins;
              font-size: 13px;
              font-weight: 500;
              text-align: left;
              color: rgba(255, 255, 255, 1);
              cursor: pointer;
            "
            @click="getDragoInventory()"
          >
            Refresh
            <img
              src="/img/genesis/icon-refresh.png"
              style="margin-left: 6px"
              width="17px"
              height="18px"
            />
          </div>
        </div>
        <div
          style="
            position: absolute;
            top: 560px;
            left: calc((100% - 1100px) / 2);
            width: 1100px;
          "
          v-bind:style="{ height: getListHeight() }"
        >
          <div v-if="myEggs.length == 0 && myDragos.length == 0">
            <div
              class="bg-empty-list"
              style="
                position: absolute;
                left: calc(50% - 40px);
                top: calc(50% - 40px);
              "
            >
              <img src="/img/genesis/select-area-drago.png" />
            </div>
            <div
              style="
                position: absolute;
                top: 480px;
                width: 100%;
                font-family: Poppins;
                font-size: 20px;
                font-weight: 500;
                font-stretch: normal;
                font-style: normal;
                line-height: 1.6;
                letter-spacing: normal;
                text-align: center;
                color: #fff;
              "
            >
              You don't have any dragos.
            </div>
          </div>
          <div v-else>
            <div
              v-for="(egg, eggIndex) in myEggs"
              v-bind:key="eggIndex"
              style="position: absolute"
              class="card-drago"
              v-bind:style="{ top: getTop(eggIndex), left: getLeft(eggIndex) }"
            >
              <div class="card-drago-top">
                <div
                  style="
                    position: absolute;
                    left: 10px;
                    top: 10px;
                    width: 240px;
                    height: 240px;
                  "
                >
                  <img
                    v-bind:src="getEggAsset(egg.tokenId)"
                    width="240px"
                    height="240px"
                  />
                </div>
              </div>
              <div class="card-drago-bottom">
                <div
                  class="card-name-text"
                  style="position: absolute; top: 20px; left: 20px"
                >
                  Drago egg
                </div>
                <div
                  class="card-tokenid-text"
                  style="position: absolute; top: 20px; right: 20px"
                >
                  #{{ egg.tokenId }}
                </div>
                <div
                  v-if="egg.status == 0"
                  @click="hatch(egg.tokenId)"
                  class="btn-hatching"
                  style="position: absolute; bottom: 16px; left: 20px"
                >
                  Hatch
                </div>
                <div
                  v-if="egg.status == 1"
                  class="btn-disable"
                  style="position: absolute; bottom: 16px; left: 20px"
                >
                  Hatching...
                </div>
              </div>
            </div>
            <div
              v-for="(drago, dragoIndex) in myDragos"
              v-bind:key="dragoIndex + myEggs.length"
              style="position: absolute"
              class="card-drago"
              v-bind:style="{
                top: getTop(myEggs.length + dragoIndex),
                left: getLeft(myEggs.length + dragoIndex),
              }"
            >
              <div class="card-drago-top">
                <div
                  style="
                    position: absolute;
                    left: 10px;
                    top: 10px;
                    width: 240px;
                    height: 240px;
                    cursor: pointer;
                  "
                  @click="detail(drago.tokenId)"
                >
                  <img
                    v-bind:src="getDragoAsset(drago.tokenId)"
                    width="240px"
                    height="240px"
                  />
                </div>
                <img
                  v-if="drago.rent != null && drago.rent.status == 1"
                  src="/img/mydrago/rental-label.png"
                  style="position: absolute; left: 0px; top: 0px"
                />
              </div>
              <div class="card-drago-bottom">
                <div
                  class="card-name-text"
                  style="position: absolute; top: 20px; left: 20px"
                >
                  Drago
                </div>
                <div
                  class="card-tokenid-text"
                  style="position: absolute; top: 20px; right: 20px"
                >
                  #{{ drago.tokenId }}
                </div>
                <div
                  @click="detail(drago.tokenId)"
                  class="btn-hatching"
                  style="position: absolute; bottom: 16px; left: 20px"
                >
                  Detail
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="tab.mydrago == 1">
        <div class="rentalTop">
          <div
            style="
              position: absolute;
              top: 560px;
              left: calc(50% - 590px);
              width: 1180px;
              height: 110px;
              border-radius: 8px;
              border: solid 0 #000;
              background-color: #fff;
            "
          >
            <img
              src="/img/mydrago/icon-bl.png"
              style="position: absolute; left: 40px; top: 49px"
            />
            <div
              style="
                position: absolute;
                left: 68px;
                top: 43px;
                font-family: Poppins;
                font-size: 16px;
                text-align: left;
                color: #000;
              "
            >
              Total DSA
            </div>
            <div
              style="
                position: absolute;
                left: 195px;
                top: 40px;
                font-family: Poppins;
                font-size: 20px;
                font-weight: 600;
                text-align: left;
                color: #0d6eff;
              "
            >
              {{ unclaimedProfit | comma }} DSA
            </div>
            <div
              style="
                width: 200px;
                height: 80px;
                border-radius: 4px;
                background-color: #0d6eff;
                cursor: pointer;
                font-family: Poppins;
                font-size: 16px;
                font-weight: 600;
                letter-spacing: -0.4px;
                text-align: center;
                color: #fff;
                padding-top: 28px;
                position: absolute;
                right: 20px;
                top: 15px;
              "
              @click="claimUnclaimedProfit()"
            >
              CLAIM
              <div
                style="
                  font-family: Poppins;
                  font-size: 13px;
                  text-align: center;
                  color: #2fd;
                "
              >
                {{ (unclaimedProfit / 100).toFixed(2) | comma }} DST
              </div>
            </div>
          </div>
          <div
            class="rentalTab rentalWrap rental"
            style="
              position: absolute;
              top: 728px;
              left: 50%;
              transform: translateX(-50%);
            "
          >
            <ul>
              <li
                v-for="(tab, idx) in rentalTab"
                v-bind:key="idx"
                v-bind:class="{ active: currentRentalTab === idx }"
              >
                <p v-on:click="onClickRentalTab(idx)">{{ tab }}</p>
              </li>
            </ul>

            <div class="item_list_content">
              <div class="rentalManage" v-show="currentRentalTab == 0">
                <div class="item_list_header">
                  <div
                    v-for="(header, headerIndex) in headers2"
                    v-bind:key="headerIndex"
                    v-bind:style="{ width: `${header[1]}px` }"
                    class="item_list_header_item"
                  >
                    {{ header[0] }}
                  </div>
                </div>
                <table>
                  <colgroup>
                    <col style="width: 350px" />
                    <col style="width: 290px" />
                    <col style="width: 270px" />
                    <col style="width: 270px" />
                  </colgroup>
                  <tr v-for="(manageItem, manageIdx) in rentManage.list"
                    v-bind:key="manageIdx" @click="detail(manageItem.tokenId)">
                    <td>
                      <span>
                        <img
                          v-bind:src="getDragoAsset(manageItem.tokenId)"
                          alt="manage img"
                        />
                      </span>
                      #{{manageItem.tokenId}}
                    </td>
                    <td>{{manageItem.rent.profitShareRatio * 10}} : {{10 - manageItem.rent.profitShareRatio * 10}}</td>
                    <td>{{manageItem.rent.stats.currentDSA | comma}}</td>
                    <td>{{manageItem.rent.stats.currentProfit | comma}} : <i>{{(manageItem.rent.stats.currentDSA - manageItem.rent.stats.currentProfit) | comma}}</i></td>
                  </tr>
                </table>
                <div
                  style="
                    margin-top: 40px;
                    width: 370px;
                    height: 40px;
                    margin-left: calc(50% - 185px);
                  "
                >
                  <div
                    class="page_button"
                    style="display: inline-block"
                    @click="onClickPageMange(rentManage.currentPage - 1)"
                  >
                    <img src="/img/icon-page-prev.png" />
                  </div>
                  <input
                    type="text"
                    style="
                      width: 70px;
                      display: inline-block;
                      margin-left: 40px;
                      height: 40px;
                      border-radius: 4px;
                      border: solid 1px #0d6eff;
                      background-color: #070920;
                      font-family: Poppins;
                      font-size: 14px;
                      letter-spacing: -0.35px;
                      text-align: center;
                      padding-left: 0px;
                      color: #fff;
                    "
                    @input="onClickPageMange(rentManage.currentPage)"
                    v-model="rentManage.currentPage"
                  />
                  <span
                    style="
                      font-family: Poppins;
                      font-size: 14px;
                      letter-spacing: -0.35px;
                      text-align: left;
                      color: #fff;
                      margin-left: 20px;
                    "
                    >of</span
                  >
                  <span
                    style="
                      font-family: Poppins;
                      font-size: 14px;
                      letter-spacing: -0.35px;
                      text-align: left;
                      color: #fff;
                      margin-left: 20px;
                    "
                    >{{ rentManage.numPage | comma }}</span
                  >
                  <div
                    class="page_button"
                    style="float: right"
                    @click="onClickPageMange(rentManage.currentPage + 1)"
                  >
                    <img src="/img/icon-page-next.png" />
                  </div>
                </div>
              </div>
              <div class="rentalHistory" v-show="currentRentalTab == 1">
                <div class="item_list_header">
                  <div
                    v-for="(header, headerIndex) in headers3"
                    v-bind:key="headerIndex"
                    v-bind:style="{ width: `${header[1]}px` }"
                    class="item_list_header_item"
                  >
                    {{ header[0] }}
                  </div>
                </div>
                <table>
                  <colgroup>
                    <col style="width: 294px" />
                    <col style="width: 294px" />
                    <col style="width: 294px" />
                    <col style="width: 294px" />
                  </colgroup>
                  <tr v-for="(historyItem, historyIdx) in rentHistory.list"
                    v-bind:key="historyIdx">
                    <td @click="goPolyscan(historyItem.to)">{{historyItem.to}}</td>
                    <td @click="detail(historyItem.dragoTokenId)">#{{historyItem.dragoTokenId}}</td>
                    <td>{{historyItem.delta | comma}}</td>
                    <td>{{historyItem.logDate | date}}</td>
                  </tr>
                </table>
                <div
                  style="
                    margin-top: 40px;
                    width: 370px;
                    height: 40px;
                    margin-left: calc(50% - 185px);
                  "
                >
                  <div
                    class="page_button"
                    style="display: inline-block"
                    @click="onClickPageHistory(rentHistory.currentPage - 1)"
                  >
                    <img src="/img/icon-page-prev.png" />
                  </div>
                  <input
                    type="text"
                    style="
                      width: 70px;
                      display: inline-block;
                      margin-left: 40px;
                      height: 40px;
                      border-radius: 4px;
                      border: solid 1px #0d6eff;
                      background-color: #070920;
                      font-family: Poppins;
                      font-size: 14px;
                      letter-spacing: -0.35px;
                      text-align: center;
                      padding-left: 0px;
                      color: #fff;
                    "
                    @input="onClickPageHistory(rentHistory.currentPage)"
                    v-model="rentHistory.currentPage"
                  />
                  <span
                    style="
                      font-family: Poppins;
                      font-size: 14px;
                      letter-spacing: -0.35px;
                      text-align: left;
                      color: #fff;
                      margin-left: 20px;
                    "
                    >of</span
                  >
                  <span
                    style="
                      font-family: Poppins;
                      font-size: 14px;
                      letter-spacing: -0.35px;
                      text-align: left;
                      color: #fff;
                      margin-left: 20px;
                    "
                    >{{ rentHistory.numPage | comma }}</span
                  >
                  <div
                    class="page_button"
                    style="float: right"
                    @click="onClickPageHistory(rentHistory.currentPage + 1)"
                  >
                    <img src="/img/icon-page-next.png" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      style="
        position: fixed;
        left: 0px;
        top: 0px;
        width: 100%;
        height: 100%;
        background-color: #00000099;
        cursor: pointer;
        z-index: 900;
      "
      v-if="
        modals.claim_drago == true ||
        modals.drago_info == true ||
        modals.hatching_egg == true ||
        modals.rehatching_egg == true ||
        modals.confirm_rehatch == true ||
        modals.confirm_claim_profit == true
      "
      @click="closeAllPopup()"
    ></div>
    <div
      v-if="modals.claim_drago"
      style="
        position: fixed;
        top: calc((100% - 674px) / 2);
        left: calc((100% - 605px) / 2);
        padding-top: 32px;
        text-align: center;
        width: 674px;
        height: 605px;
        background-image: url('/img/genesis/popup-base.png');
        z-index: 10000;
      "
    >
      <div
        style="
          position: absolute;
          left: calc((100% - 300px) / 2);
          top: calc((100% - 300px) / 2);
          width: 300px;
          height: 300px;
        "
      >
        <img v-bind:src="getDragoAsset(10001)" />
      </div>
      <div
        style="
          position: absolute;
          top: 458px;
          left: 17px;
          width: 640px;
          height: 110px;
          border: solid 0 #fff;
          background-color: #e6e7ec;
        "
      >
        <div
          @click="onClickClaimDrago()"
          class="popup-btn"
          style="position: absolute; left: 180px; top: 20px; cursor: pointer"
        >
          CLAIM
        </div>
      </div>
    </div>
    <div
      v-if="modals.hatching_egg"
      style="
        position: fixed;
        top: calc((100% - 640px) / 2);
        left: calc((100% - 560px) / 2);
        padding-top: 32px;
        text-align: center;
        width: 640px;
        height: 560px;
        background-image: url('/img/mydrago/popupbase.png');
        z-index: 10000;
      "
    >
      <div
        class="popup-head-text"
        style="position: absolute; left: 0px; top: 20px; width: 100%"
      >
        Hatching processing
      </div>
      <div
        class="popup-content-text"
        style="
          position: absolute;
          left: 5%;
          top: 160px;
          width: 90%;
          height: 200px;
        "
      >
        Wait for hatching egg...<br /><br />
        It may take up to 20-60 minutes depending on the Ethereum network &
        Chainlink VRF situation.<br /><br />
        After hatching, you can see the drago in your inventory.
      </div>
      <!-- <div
        id="loading-image"
        style="position: absolute; left: calc(50% - 40px); bottom: 150px"
      ></div> -->
      <div
        style="
          position: absolute;
          top: 450px;
          left: 0px;
          width: 640px;
          height: 110px;
          border: solid 0 #fff;
          background-color: #e6e7ec;
        "
      >
        <div
          @click="onClickOKHatching()"
          class="popup-btn"
          style="position: absolute; left: 180px; top: 20px; cursor: pointer"
        >
          OK
        </div>
      </div>
    </div>
    <div
      v-if="modals.rehatching_egg"
      style="
        position: fixed;
        top: calc((100% - 640px) / 2);
        left: calc((100% - 560px) / 2);
        padding-top: 32px;
        text-align: center;
        width: 640px;
        height: 560px;
        background-image: url('/img/mydrago/popupbase.png');
        z-index: 10000;
      "
    >
      <div
        class="popup-head-text"
        style="position: absolute; left: 0px; top: 20px; width: 100%"
      >
        Rehatching processing
      </div>
      <div
        class="popup-content-text"
        style="
          position: absolute;
          left: 5%;
          top: 160px;
          width: 90%;
          height: 200px;
        "
      >
        Wait for rehatching drago...<br /><br />
        It may take up to 20-60 minutes depending on the Ethereum network &
        Chainlink VRF situation.<br /><br />
        After rehatching, you can see the drago in your inventory.
      </div>
      <!-- <div
        id="loading-image"
        style="position: absolute; left: calc(50% - 40px); bottom: 150px"
      ></div> -->
      <div
        style="
          position: absolute;
          top: 450px;
          left: 0px;
          width: 640px;
          height: 110px;
          border: solid 0 #fff;
          background-color: #e6e7ec;
        "
      >
        <div
          @click="closeAllPopup()"
          class="popup-btn"
          style="position: absolute; left: 180px; top: 20px; cursor: pointer"
        >
          OK
        </div>
      </div>
    </div>
    <div
      v-if="modals.confirm_rehatch == true"
      style="
        position: fixed;
        top: calc((100% - 640px) / 2);
        left: calc((100% - 560px) / 2);
        padding-top: 32px;
        text-align: center;
        width: 640px;
        height: 560px;
        background-image: url('/img/mydrago/popupbase.png');
        z-index: 10000;
      "
    >
      <div
        class="popup-head-text"
        style="position: absolute; left: 0px; top: 20px; width: 100%"
      >
        Confirm rehatch
      </div>
      <div
        class="popup-content-text"
        style="
          position: absolute;
          left: 5%;
          top: 180px;
          width: 90%;
          height: 200px;
        "
      >
        Due to the error in the transaction, we give you a chance to re-hatch
        the Drago. <br />
        It will reroll the parts following the Drago Genesis rule. <br /><br />
        This action can only be done once, and it is impossible to revert this
        action.
      </div>
      <!-- <div
        id="loading-image"
        style="position: absolute; left: calc(50% - 40px); bottom: 150px"
      ></div> -->
      <div
        style="
          position: absolute;
          top: 450px;
          left: 0px;
          width: 640px;
          height: 110px;
          border: solid 0 #fff;
          background-color: #e6e7ec;
        "
      >
        <div
          @click="onClickOKRehatching()"
          class="popup-btn"
          style="
            position: absolute;
            left: 60px;
            top: 20px;
            cursor: pointer;
            width: 240px;
          "
        >
          Confirm
        </div>
        <div
          @click="closeAllPopup()"
          class="popup-btn"
          style="
            position: absolute;
            right: 60px;
            top: 20px;
            cursor: pointer;
            width: 240px;
          "
        >
          Cancel
        </div>
      </div>
    </div>
    <div
      v-if="modals.confirm_claim_profit == true"
      style="
        position: fixed;
        top: calc((100% - 640px) / 2);
        left: calc((100% - 560px) / 2);
        padding-top: 32px;
        text-align: center;
        width: 640px;
        height: 560px;
        background-image: url('/img/mydrago/popupbase.png');
        z-index: 10000;
      "
    >
      <div
        class="popup-head-text"
        style="position: absolute; left: 0px; top: 20px; width: 100%"
      >
        Confirm claim profit
      </div>
      <div
        class="popup-content-text"
        style="
          position: absolute;
          left: 5%;
          top: 180px;
          width: 90%;
          height: 200px;
        "
      >
        Total : {{ (unclaimedProfit / 100).toFixed(2) | comma }} DST<br />
        Fee : 0.1 DST<br />
        Claim : {{ ((unclaimedProfit - 10) / 100).toFixed(2) | comma }} DST
      </div>
      <div
        style="
          position: absolute;
          top: 450px;
          left: 0px;
          width: 640px;
          height: 110px;
          border: solid 0 #fff;
          background-color: #e6e7ec;
        "
      >
        <div
          @click="onClickConfirmClaim()"
          class="popup-btn"
          style="
            position: absolute;
            left: 60px;
            top: 20px;
            cursor: pointer;
            width: 240px;
          "
        >
          Claim
        </div>
        <div
          @click="closeAllPopup()"
          class="popup-btn"
          style="
            position: absolute;
            right: 60px;
            top: 20px;
            cursor: pointer;
            width: 240px;
          "
        >
          Cancel
        </div>
      </div>
    </div>
    <div
      v-if="modals.drago_info"
      style="
        position: fixed;
        top: calc((100% - 720px) / 2);
        left: calc((100% - 740px) / 2);
        text-align: center;
        width: 720px;
        height: 740px;
        background-image: url('/img/mydrago/popupbase_large.png');
        z-index: 10000;
      "
    >
      <div
        class="popup-head-text"
        style="position: absolute; left: 0px; top: 25px; width: 100%"
      >
        DRAGO #{{ detail_drago.tokenId }}
      </div>
      <div
        style="
          position: absolute;
          left: calc((100% - 512px) / 2);
          top: calc((100% - 542px) / 2);
          width: 512px;
          height: 512px;
        "
      >
        <img v-bind:src="getDragoAsset(detail_drago.tokenId)" />
      </div>
      <div
        style="
          position: absolute;
          bottom: 0px;
          left: 0px;
          width: 720px;
          height: 110px;
          border: solid 0 #fff;
          background-color: #e6e7ec;
        "
      >
        <div
          @click="onClickOK()"
          class="popup-btn"
          style="
            position: absolute;
            left: calc(50% - 140px);
            top: 20px;
            cursor: pointer;
          "
        >
          OK
        </div>
        <div
          v-if="detail_drago.rehatching > 0"
          @click="rehatch(detail_drago.tokenId)"
          style="
            position: absolute;
            right: 30px;
            padding-top: 40px;
            font-family: Poppins;
            font-size: 13px;
            font-weight: 500;
            line-height: 3.23;
            letter-spacing: -0.33px;
            text-align: center;
            cursor: pointer;
            color: #7e8499;
          "
        >
          <img src="/img/mydrago/icon-rehatching.png" />
          <span style="margin-left: 10px">Rehatch</span>
        </div>
      </div>
    </div>
  </div>
  <div v-else></div>
</template>
<script>
import { Parallax } from "@/components";
import config from "../config.js";
import axios from "axios";
import moment from "moment";
import {
  hatchDrago,
  rehatchDrago,
  connectWallet,
  getNetwork,
  changeNetwork,
} from "../utils/wallet";

export default {
  name: "myDrago",
  bodyClass: "myDrago-page",
  components: {
    Parallax,
  },
  created() {},

  mounted: async function () {
    await connectWallet(this.$store);
    this.getDragoInventory();
  },
  beforeDestroy() {},
  methods: {
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
    closeAllPopup() {
      this.modals.claim_drago = false;
      this.modals.confirm_claim_profit = false;
      this.modals.drago_info = false;
      this.modals.hatching_egg = false;
      this.modals.rehatching_egg = false;
      this.modals.confirm_rehatch = false;
    },
    closeModal(modal) {
      this.modals[modal] = false;
    },
    openModal(modal) {
      this.closeAllPopup();

      this.modals[modal] = true;
    },
    getEggAsset(tokenId) {
      return `${config.api.egg_url}/${tokenId}`;
    },
    getDragoAsset(tokenId) {
      return `${config.api.drago_url}/${tokenId}`;
    },
    getTop(index) {
      return Math.floor(index / 4) * 413 + "px";
    },
    getLeft(index) {
      return (index % 4) * 280 + "px";
    },
    getListHeight() {
      let num = this.myEggs.length + this.myDragos.length;
      let row = Math.floor((num - 1) / 4) + 1;
      if (row <= 2) {
        return "806px";
      }
      return 393 * row + 20 * (row - 1) + "px";
    },
    getTotalHeight() {
      if (this.tab.mydrago == 0) {
        let num = this.myEggs.length + this.myDragos.length;
        let row = Math.floor((num - 1) / 4) + 1;
        if (row <= 2) {
          return "1106px";
        }
        return 200 + 393 * row + 20 * (row - 1) + "px";
      }
      else {
        return "1230px";
      }
    },
    async startHatching(eggId, txHash) {
      let address = "";
      if (
        this.$store.state.account != null &&
        this.$store.state.account.wallet != null
      ) {
        address = this.$store.state.account.wallet.address;
      }

      var ret = await axios.post(`${config.api.nft_url}/drago/hatch/start`, {
        address: address,
        tokenId: eggId,
        txHash: txHash,
      });
      if (ret.data.result) {
        await this.getDragoInventory();
      }
    },
    async getDragoInventory() {
      let address = "";
      if (
        this.$store.state.account != null &&
        this.$store.state.account.wallet != null
      ) {
        address = this.$store.state.account.wallet.address;
      }

      var ret = await axios.post(`${config.api.nft_url}/drago/inventory`, {
        address: address,
        includeRent: true,
      });
      console.log(ret.data);
      if (ret.data.result) {
        this.myDragos = ret.data.myDragos;
        this.myEggs = ret.data.myEggs;
      }
    },
    async getRentalList() {
      let address = "";
      if (
        this.$store.state.account != null &&
        this.$store.state.account.wallet != null
      ) {
        address = this.$store.state.account.wallet.address;
      }

      var ret = await axios.post(`${config.api.nft_url}/drago/rent/list`, {
        address: address
      });
      console.log(ret.data);
      if (ret.data.result) {
        this.rentalDragos = ret.data.dragos;
      }
    },
    async getRentalInfo() {
      let address = "";
      if (
        this.$store.state.account != null &&
        this.$store.state.account.wallet != null
      ) {
        address = this.$store.state.account.wallet.address;
      }

      var ret = await axios.post(`${config.api.game_url}/drago/rent/info`, {
        address: address,
      });
      console.log(ret.data);
      if (ret.data.result) {
        this.unclaimedProfit = ret.data.unclaimedProfit;
      }
    },
    async onClickPageMange(page) {
      if (page <= 0) {
        page = 1;
      }
      if (page >= this.rentManage.numPage) {
        page = this.rentManage.numPage;
      }
      await this.getRentalManage(page);
    },
    async onClickPageHistory(page) {
      if (page <= 0) {
        page = 1;
      }
      if (page >= this.rentHistory.numPage) {
        page = this.rentHistory.numPage;
      }
      await this.getRentalHistory(page);
    },
    async getRentalManage(page) {
      let address = "";
      if (
        this.$store.state.account != null &&
        this.$store.state.account.wallet != null
      ) {
        address = this.$store.state.account.wallet.address;
      }

      var ret = await axios.post(`${config.api.game_url}/drago/rent/manage/list`, {
        address: address,
        page: page
      });
      console.log(ret.data);
      if (ret.data.result) {
        this.rentManage.list = ret.data.dragos;
        this.rentManage.numPage = Math.floor((ret.data.numPage - 1) / 5) + 1;
        if (this.rentManage.numPage == 0) {
          this.rentManage.numPage = 1;
        }
        console.log(this.rentManage.numPage);
        if (page == null) {
          page = 1;
        }
        this.rentManage.currentPage = page;
      }
    },
    async getRentalHistory(page) {
      let address = "";
      if (
        this.$store.state.account != null &&
        this.$store.state.account.wallet != null
      ) {
        address = this.$store.state.account.wallet.address;
      }

      var ret = await axios.post(`${config.api.game_url}/drago/rent/manage/history`, {
        address: address,
        page: page
      });
      console.log(ret.data);
      if (ret.data.result) {
        this.rentHistory.list = ret.data.history;
        this.rentHistory.numPage = Math.floor((ret.data.numPage - 1) / 10) + 1;
        if (this.rentHistory.numPage == 0) {
          this.rentHistory.numPage = 1;
        }
        if (page == null) {
          page = 1;
        }
        this.rentHistory.currentPage = page;
      }
    },
    async claimUnclaimedProfit() {
      if (this.unclaimedProfit < 1000) {
        this.$store.commit(
          "alert",
          `You can only claim DSA if you have more than 1000 DSA.`
        );
        return;
      }
      this.closeAllPopup();
      this.openModal("confirm_claim_profit");
    },
    async onClickConfirmClaim() {
      let address = "";
      if (
        this.$store.state.account != null &&
        this.$store.state.account.wallet != null
      ) {
        address = this.$store.state.account.wallet.address;
      }

      var ret = await axios.post(`${config.api.game_url}/drago/rent/claim`, {
        address: address,
      });
      console.log(ret.data);
      if (ret.data.result) {
        this.$store.commit(
          "alert",
          `You will receive ${((ret.data.unclaimedProfit - 10) / 100).toFixed(
            2
          )} DST.`
        );
      }
      this.closeAllPopup();
      await this.getRentalInfo();
    },
    async onClickMyDrago(idx) {
      switch (idx) {
        case 1:
          await this.getRentalInfo();
          await this.getRentalManage();
          break;
      }

      this.tab.mydrago = idx;
    },
    async onClickOKRehatching() {
      this.closeAllPopup();

      let tokenId = this.detail_drago.tokenId;
      let self = this;
      //
      rehatchDrago(this.$store, tokenId)
        .on("transactionHash", async (txHash) => {
          console.log("transactionHash");
          console.log(txHash);
          self.openModal("rehatching_egg");
          // self.openModal("claim_egg");
          // await self.startHatching(tokenId, txHash);
        })
        .on("receipt", async (receipt) => {
          console.log("receipt");
          // console.log(parseInt(receipt.logs[0].topics[3], 16));
          // self.openModal("claim_drago");
          // resolve({result: true, data: receipt});
          // await self.getDragoInventory();
          await self.getDragoInventory();
        })
        .on("error", (error) => {
          console.log("error");
          console.log(error);
          if (error != null) {
            alert(error);
          }
        });
    },
    async rehatch(tokenId) {
      this.openModal("confirm_rehatch");
    },
    async hatch(tokenId) {
      // this.$store.commit('alert', `The hatch function is temporarily suspended due to some problems.`);
      // return;

      let isExist = false;
      let egg = null;
      for (let item of this.myEggs) {
        // for (let i = 0; i < this.myEggs.length; ++i) {
        if (item.tokenId == tokenId) {
          isExist = true;
          egg = item;
          break;
        }
      }
      if (!isExist) {
        return;
      }

      let self = this;
      let networkId = await getNetwork();
      if (egg.network == 0 && networkId != config.network.eth) {
        networkId = await changeNetwork(config.network.eth);
        if (networkId != config.network.eth) return;
      } else if (egg.network == 1 && networkId != config.network.polygon) {
        networkId = await changeNetwork(config.network.polygon);
        if (networkId != config.network.polygon) return;
      }
      hatchDrago(this.$store, tokenId, egg.network)
        .on("transactionHash", async (txHash) => {
          console.log("transactionHash");
          console.log(txHash);
          self.openModal("hatching_egg");
          // self.openModal("claim_egg");
          await self.startHatching(tokenId, txHash);
        })
        .on("receipt", async (receipt) => {
          console.log("receipt");
          // console.log(parseInt(receipt.logs[0].topics[3], 16));
          // self.openModal("claim_drago");
          // resolve({result: true, data: receipt});
          await self.getDragoInventory();
        })
        .on("error", (error) => {
          console.log("error");
          console.log(error);
          if (error != null) {
            alert(JSON.stringify(error));
          }
        });
    },
    goPolyscan(address) {
      let url = `${config.polygonscan.url}/address/${address}`;
      window.open(url, "_blank");
    },
    async detail(tokenId) {
      let url = `/drago/detail/${tokenId}`;
      window.open(url, "_blank");
      // let ret = await axios.post(`${config.api.nft_url}/drago/detail/${tokenId}`, {});

      // if (ret.data.result == true) {
      //   let isExist = false;
      //   for (let i = 0; i < this.myDragos.length; ++i) {
      //     if (this.myDragos[i].tokenId == tokenId) {
      //       isExist = true;
      //       break;
      //     }
      //   }
      //   if (!isExist) {
      //     return;
      //   }

      //   this.detail_drago = ret.data.drago;
      //   this.openModal("drago_info");
      // }

      // // this.detail_drago = {
      // //   tokenId: tokenId,
      // //   rehatching: 0
      // // }
      // // this.openModal("drago_info");
    },
    onClickClaimDrago() {
      this.closeModal("claim_drago");
    },
    async onClickRentalTab(idx) {
      this.currentRentalTab = idx
      switch(idx) {
        case 0:
          await this.getRentalManage();
          break;
        case 1:
          await this.getRentalHistory();
          break;
      }
    },
    async onClickOK() {
      //await this.getDragoInventory();
      this.closeModal("drago_info");
    },
    async onClickOKHatching() {
      //await this.getDragoInventory();
      this.closeModal("hatching_egg");
    },
  },
  watch: {
    "$store.state.account.wallet": async function (val) {
      await this.getDragoInventory();
    },
  },
  filters: {
    comma(val) {
      return Number(val).toLocaleString("en-US");
      //return String(val).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    },
    date(val) {
      if (val) {
        return moment(String(val)).format("YYYY-MM-DD HH:mm");
      }
    },
  },
  data: function () {
    return {
      modals: {
        claim_drago: false,
        drago_info: false,
        hatching_egg: false,
        confirm_rehatch: false,
        rehatching_egg: false,
        confirm_claim_profit: false,
      },
      rentManage: {
        list: [],
        numPage: 0,
        currentPage: 0
      },
      rentHistory: {
        list: [],
        numPage: 0,
        currentPage: 0
      },
      detail_drago: {
        tokenId: 0,
        rehatching: 0,
      },
      rentalDragos: [],
      myDragos: [],
      myEggs: [],
      tab: {
        mydrago: 0,
      },
      unclaimedProfit: 0,
      currentRentalTab: 0,
      rentalTab: ["Manage", "History"],
      // Rentar > Manage 타이틀명과 width값 리턴
      headers2: [
        ["Drago", 350],
        ["Distribution ratio", 290],
        ["Mining DSA", 270],
        ["Distribution DSA", 270],
      ],
      //Rentar > History 타이틀명과 width값 리턴
      headers3: [
        ["Borrower", 294],
        ["drago", 294],
        ["Mining DSA", 294],
        //["renter: borrower", 196],
        //["status", 196],
        ["Date", 294],
      ],
    };
  },
};
</script>
<style>
.rentalTab {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-family: Poppins, sans-serif;
}
.rentalTab ul {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 584px;
  height: 60px;
  padding: 0;
  border-radius: 30px;
  background-color: #2d324e;
}
.rentalTab ul li {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 280px;
  height: 44px;
  border-radius: 30px;
  color: rgba(255, 255, 255, 0.4);
  transition: all 0.3s;
}
.rentalTab ul li.active {
  box-shadow: 0px 4px 4px 0 rgba(0, 0, 0, 0.2);
  background-color: #091033;
  color: #fff;
}
.rentalTab ul li p {
  width: 100%;
  height: 100%;
  line-height: 44px;
  margin: 0;
  text-align: center;
  cursor: pointer;
}
.item_list_header {
  width: 1180px;
  height: 85px;
  margin-left: calc(50% - 590px);
}

.item_list_header_item {
  float: left;
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: rgba(65, 110, 255, 0.7);
  text-align: center;
  padding-top: 60px;
  padding-bottom: 30px;
  border-bottom: 1px solid rgba(87, 98, 136, 0.5);
}
.rental table {
  width: 1180px;
  cursor: pointer;
}
.rental table tr:hover {
  background-color: #141b52;
  transition: all 0.3s;
}
.rental .rentalManage table td {
  line-height: 1;
  padding: 11px 0;
  border-bottom: 1px solid rgba(87, 98, 136, 0.5);
  color: #fff;
  font-size: 15px;
  font-weight: 500;
  text-align: center;
}
.rental .rentalManage table td:nth-child(1) {
  padding: 11px 0 11px 10px;
  text-align: left;
}
.rental table td span {
  display: inline-block;
  width: 80px;
  height: 80px;
  margin: 0 20px 0 0;
  border-radius: 8px;
  background-color: #171c3e;
}
.rental table td i {
  color: #fff000;
  font-style: normal;
}
.rental .rentalHistory table td {
  line-height: 1;
  padding: 20px 0;
  border-bottom: 1px solid rgba(87, 98, 136, 0.5);
  color: #fff;
  font-size: 13px;
  font-weight: 500;
  text-align: center;
}
.page_button {
  cursor: pointer;
  width: 60px;
  height: 40px;
  padding: 8px 22px 14px 21px;
  border-radius: 4px;
  border: solid 1px #1f156b;
  background-color: #080f3a;
}

.page-header {
  max-height: none !important;
}

.bg_bonus-area {
  width: 100%;
  border: solid 0 #000;
  background-color: #04050d;
}

.MY-DRAGO {
  position: relative;
  width: 800px;
  height: 80px;
  margin-top: 25px;
  margin-left: calc(50% - 400px);
  background-image: linear-gradient(to right, #ff9c00, #f4ff3f),
    linear-gradient(to bottom, #fff600, #fff600);
  font-size: 72px;
  font-weight: 900;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: -1.8px;
  text-align: center;
  color: #fff600;
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.card-drago {
  width: 260px;
  height: 393px;
  border-radius: 4px;
  background-color: #fff;
}

.card-drago-top {
  width: 260px;
  height: 260px;
  border: solid 0 #000;
  background-color: #e6e7ec;
  position: absolute;
  top: 0px;
  left: 0px;
}

.card-drago-bottom {
  width: 260px;
  height: 133px;
  position: absolute;
  top: 260px;
  left: 0px;
}

.card-name-text {
  font-family: Poppins;
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #202431;
}

.card-tokenid-text {
  font-family: Poppins;
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: right;
  color: #202431;
}

.btn-hatching {
  width: 220px;
  height: 60px;
  border: solid 0 #000;
  background-color: #3920d7;
  font-family: Poppins;
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #fff;
  padding-top: 20px;
  cursor: pointer;
}

.btn-disable {
  width: 220px;
  height: 60px;
  border: solid 0 #000;
  background-color: #c0c5d5;
  font-family: Poppins;
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #fff;
  padding-top: 20px;
}

.popup-head-text {
  font-family: Poppins;
  font-size: 24px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
  text-align: center;
  color: #fff;
}

.popup-btn {
  width: 280px;
  height: 70px;
  border-radius: 2px;
  border: solid 0 #000;
  background-color: #0a1844;
  font-family: Poppins;
  padding-top: 22px;
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #fff;
}

#loading-image {
  height: 80px;
  width: 80px;
  background: url("/img/genesis/loading.png") 0px 0px;
  animation: play 0.8s steps(8) infinite;
}
@keyframes play {
  100% {
    background-position: -640px;
  }
}

.bg-empty-list {
  width: 80px;
  height: 80px;
  padding: 19px 14px 20px;
  border-radius: 40px;
  border: solid 0 #000;
  background-color: #202431;
}
</style>
